import { EMeasuringUnit } from "../interface/IUsage";
import { format } from "date-fns";
import { DATE_FORMAT } from "@constants";
import { IUsageSummaryList } from "../interface/IUsageSummary";

export interface IUsageSummaryResponse {
    eventCount: number;
    ratingSubtotalId: number;
    ratingSubtotalTypeDisplayName: string;
    ratingSubtotalTypeId: number;
    ratingSubtotalTypeKey: string;
    ratingSubtotalTypeLevel: string;
    amount: number;
    amountFourDecimals: number;
    duration: number;
    measuringUnit: EMeasuringUnit;
    quantity: number;
}

export interface IUsageSummaryListResponse {
    usageSummary: IUsageSummaryResponse[];
    billPeriodStartDate: string;
    billPeriodEndDate: string;
}

export const getResponseToState = (response: IUsageSummaryListResponse): IUsageSummaryList => ({
    usageSummary: response.usageSummary.map((usage) => ({
        amount: usage.amount,
        amountFourDecimals: usage.amountFourDecimals,
        duration: usage.duration,
        quantity: usage.quantity,
        measuringUnit: usage.measuringUnit,
        ratingSubtotalId: usage.ratingSubtotalId,
        ratingSubtotalTypeDisplayName: usage.ratingSubtotalTypeDisplayName,
        ratingSubtotalTypeId: usage.ratingSubtotalTypeId,
        eventCount: usage.eventCount,
        ratingSubtotalTypeLevel: usage.ratingSubtotalTypeLevel,
        ratingSubtotalTypeKey: usage.ratingSubtotalTypeKey,
    })),
    billPeriodStartDate: format(new Date(response.billPeriodStartDate), DATE_FORMAT),
    billPeriodEndDate: format(new Date(response.billPeriodEndDate), DATE_FORMAT),
});
